import BlockRouter, { BlockTypes } from "@/components/blocks/BlockRouter";
import { ContentPage as ContentPageType } from "graphql/generated-types";
import Image from "next/image";
import PageInner from "./PageInner";

const ContentPage = ({ data: { title, heroImage, body, id } }: { data: ContentPageType }) => {
	return (
		<PageInner>
			<div className="mt-20 lg:mt-56">
				<h1 className="mb-4 text-lg leading-snug lg:mb-24 lg:w-1/2 lg:text-2xl">{title}</h1>
				<Image
					className="mb-10 h-auto w-full rounded"
					src={heroImage?.rendition?.url!}
					alt={heroImage?.rendition?.image.title!}
					width={heroImage?.rendition?.width}
					height={heroImage?.rendition?.height}
				/>
				<BlockRouter blocks={body! as [BlockTypes]} pageId={id} />
			</div>
		</PageInner>
	);
};

export default ContentPage;
